<template>
  <main class="contaniner-pay">
    <!-- 顶通 -->
    <div class="-Topbar" menu-index="3"></div>

    <section class="container">
      <!--tab切换-->
      <tabs></tabs>
      <div class="table-wrap">
        <div class="table-title">
          <el-row :gutter="24">
            <el-col
              v-for="(item, index) in colheader"
              :key="index"
              :span="item.span"
              ><div class="grid-content">{{ item.name }}</div></el-col
            >
          </el-row>
        </div>
        <div class="table-con" v-if="historyList.length">
          <el-row
            :gutter="24"
            v-for="(item, index) in historyList"
            :key="index"
          >
            <el-col :span="3"
              ><div class="grid-content">
                {{ item.order_time || "--" }}
              </div></el-col
            >
            <el-col :span="3"
              ><div class="grid-content">
                {{ item.order_no || "--" }}
              </div></el-col
            >
            <el-col :span="3"
              ><div class="grid-content mt36">
                <div class="grid-line">{{ item.game_name || "--" }}</div>
                <div class="popover" v-if="item.game_name">
                  {{ item.game_name }}
                </div>
              </div></el-col
            >
            <el-col :span="3">
              <div class="grid-content mt36">
                <div class="grid-line">{{ item.cp_role_name || "--" }}</div>
                <div class="popover" v-if="item.cp_role_name">
                  {{ item.cp_role_name }}
                </div>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="grid-content mt36" v-if="item.product_name">
                <div class="grid-line">
                  {{ item.product_name }}
                </div>
                <div class="popover" v-if="item.product_name">
                  {{ item.product_name }}
                </div>
              </div>
              <div class="grid-content mt36" v-else>
                <div class="grid-line">
                  <span class="desc">{{ item.description1 }}</span
                  >{{ item.description2 }}
                </div>
                <div
                  class="popover"
                  v-if="item.description1 || item.description2"
                >
                  <span class="desc">{{ item.description1 }}</span
                  >{{ item.description2 }}
                </div>
              </div>
            </el-col>
            <el-col :span="3">
              <div class="grid-content mt36">
                <div class="grid-line">
                  {{ $t(`paygame.paymode${item.pay_mode}`) || "--" }}
                </div>
                <div class="popover" v-if="item.pay_mode">
                  {{ $t(`paygame.paymode${item.pay_mode}`) }}
                </div>
              </div>
            </el-col>
            <el-col :span="2"
              ><div class="grid-content">
                {{ item.product_price + item.currency || "--" }}
              </div></el-col
            >
            <el-col :span="3">
              <div class="grid-content">
                <span
                  class="status-tag"
                  :class="{
                    pending: item.status == 0,
                    success: item.status == 1,
                    fail: item.status != 1 && item.status != 0,
                  }"
                  >{{
                    item.status == 0 || item.status == 1
                      ? statusDes[item.status]
                      : statusDes[3]
                  }}</span
                >
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="emptyData" v-if="!loading && !historyList.length">
          {{ $t("common.emptyData") }}
        </div>
        <el-pagination
          v-if="historyList.length"
          layout="prev, pager, next"
          @current-change="getOrderHistory"
          :current-page.sync="pageOptions.pageIndex"
          :page-size="pageOptions.pageSize"
          :total="pageOptions.totalNum"
          ga-data="2801002"
        >
        </el-pagination>
      </div>
    </section>

    <modal-history
      v-if="resPop"
      :type="popType"
      :order="orderInfo"
      @closeModal="closeModal"
    ></modal-history>

    <!-- loading -->
    <loading class="bui-loading" v-show="loading"></loading>

    <!-- 底通 -->
    <div class="-Footer"></div>
  </main>
</template>

<script>
// import Vue from "vue";
import Cookies from "js-cookie";
import { mapGetters } from "vuex";
require("../elementUI/elementUI");

import tabs from "./component/tabs/index.vue";
import loading from "@/component/loading/index.vue";
import modalHistory from "./component/modal/modal-history/index.vue";

export default {
  name: "index",
  data() {
    return {
      distribution_region: 5,
      // 表头
      colheader: {
        order_time: {
          name: this.$t("paygame.payTime"),
          span: 3,
        },
        order_no: {
          name: this.$t("paygame.orderNo"),
          span: 3,
        },
        game_name: {
          name: this.$t("paygame.paygameName"),
          span: 3,
        },
        cp_role_name: {
          name: this.$t("paygame.roleNick"),
          span: 3,
        },
        product_name: {
          name: this.$t("paygame.payProduct"),
          span: 4,
        },
        pay_mode_name: {
          name: this.$t("paygame.payWay"),
          span: 3,
        },
        product_price: {
          name: this.$t("paygame.orderPrice"),
          span: 2,
        },
        status: {
          name: this.$t("paygame.orderStatus"),
          span: 3,
        },
      },
      // 分页信息
      pageOptions: {
        pageSize: 10,
        pageIndex: 1,
        totalNum: 0,
      },
      // 订单历史数据
      historyList: [],
      // loading
      loading: false,
      // 订单装状态
      statusDes: [
        this.$t("paygame.orderPending"),
        this.$t("paygame.orderSuccess"),
        this.$t("paygame.orderFailed"),
      ],
      // 控制弹窗的显示和隐藏
      resPop: false,
      // 成功或失败
      popType: "",
      // 订单信息
      orderInfo: {},
    };
  },
  components: {
    tabs,
    loading,
    modalHistory,
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  methods: {
    closeModal() {
      this.resPop = false;
    },
    // 获取订单历史
    getOrderHistory() {
      this.loading = true;
      this.$apis.paygame
        .getOrderHistory(
          this.distribution_region,
          this.pageOptions.pageIndex,
          this.pageOptions.pageSize,
          Cookies.get("joy_jct")
        )
        .then(({ data }) => {
          if (data.code === 0 && data.data.total_count > 0) {
            this.pageOptions.totalNum = data.data.total_count;
            this.pageOptions.pageIndex = data.data.page_number || 1;
            this.historyList = data.data.result_list;
          }
          this.loading = false;
        });
    },
    // 订单详情查询
    getOrderResult(pay_order_no) {
      this.$apis.paygame
        .getOrderResult(this.distribution_region, pay_order_no)
        .then(({ data }) => {
          if (data.code == 0) {
            // 进入成功页面
            if (data.data.pay_status == 1) {
              this.popType = "success";
            } else {
              this.popType = "fail";
              this.orderInfo.show_msg = this.$t("paygame.notPaied");
              // this.orderInfo.show_msg = data.data.show_msg;
            }
            this.orderInfo.pay_order_no = data.data.pay_order_no;

            this.resPop = this.orderInfo.pay_order_no ? true : false;
          }
        });
    },
    // 获取平台充值开关状态
    getSwitchStatus() {
      this.$apis.paygame
        .getSwitchStatus(this.distribution_region)
        .then(({ data }) => {
          // 判断开关是否开启
          if (
            data.code === 0 &&
            data.data.main_switch_status === 1 &&
            data.data.secondary_switch_status === 1
          ) {
            // 判断是否登录
            // console.log(this.userInfo.mid)
            if (this.userInfo.mid) {
              if (this.$utils.getParams("pay_order_no")) {
                this.getOrderResult(this.$utils.getParams("pay_order_no"));
              }
              // 获取订单历史
              this.getOrderHistory();
            } else {
              this.$router.push({
                name: "login",
                query: { redirect: location.href },
              });
            }
          } else {
            this.$router.push({ name: "home" });
          }
        });
    },
  },
  created() {
    // 获取平台充值开关状态
    this.getSwitchStatus();
  },
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>

<style lang="scss">
@import "./index.scss";
.contaniner-pay {
  .paygame-tab {
    width: 1250px;
  }
  .container {
    margin: 0 auto;
    width: 1250px;
    .grid-content {
      position: relative;
      width: 100%;
      &.mt36 {
        position: relative;
        overflow: visible !important;
        cursor: pointer;
        &:hover {
          .popover {
            display: block;
          }
        }
        .popover {
          display: none;
          position: absolute;
          z-index: 10;
          top: 100%;
          left: 50%;
          padding: 10px 20px;
          min-width: 100px;
          line-height: 18px;
          text-align: left;
          color: #444;
          background: #2ebdf3;
          border: 1px solid #14b0f6;
          border-radius: 10px;
          box-sizing: border-box;
          animation: fadeIn 0.2s forwards;
        }
      }
      .status-tag {
        display: inline-block;
        padding: 0 8px;
        height: 25px;
        line-height: 25px;
        font-size: 12px;
        color: #fff;
        border-radius: 20px;
        &.pending {
          background-color: #ffd6b2;
        }
        &.success {
          background-color: #7ad1b9;
        }
        &.fail {
          background-color: #ff9697;
        }
      }
      .grid-line {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        &.sf {
          font-size: 12px;
          color: #999;
        }
      }
      .desc {
        padding-right: 10px;
      }
    }
  }
}

.el-select .el-input .el-select__caret {
  margin-right: 10px;
  width: 12px;
  background-size: 100% auto;
  background-position: center;
  &:before {
    content: "";
  }
}
.table-wrap {
  margin-top: 40px;
  margin-bottom: 120px;
  text-align: center;
  .emptyData {
    padding-top: 50px;
    color: #b5b5b5;
    font-size: 16px;
  }
}
.table-title {
  height: 50px;
  line-height: 50px;
  font-size: 14px;
  color: #3c3c3c;
  background: #fbfbfb;
  border-radius: 10px;
  .el-row {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
}
.table-con {
  line-height: 60px;
  min-height: 305px;
  font-size: 14px;
  color: #444444;
  text-align: center;
  border-bottom: 1px solid #ebebeb;
  padding-top: 10px;
  .grid-content {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .el-row {
    margin-left: 0 !important;
    margin-right: 0 !important;
    transition: color 0.1s;
    &:last-child {
      border: none;
    }
    &:hover {
      color: #2ebdf3;
      .grid-line.sf {
        color: #2ebdf3;
      }
    }
  }
}

.el-pagination {
  margin-top: 25px;
  .el-pager {
    margin-top: 3px;
    .number {
      color: #c7c7c7;
    }
    .active {
      color: #3b3b3b;
    }
    .btn-quicknext,
    .btn-quickprev {
      color: #c7c7c7;
    }
  }
  .btn-prev,
  .btn-next {
    .el-icon-arrow-left,
    .el-icon-arrow-right {
      width: 30px;
      height: 30px;
      line-height: 30px;
      border: 1px solid #36c0f4;
      border-radius: 30px;
    }
    .el-icon-arrow-left:before,
    .el-icon-arrow-right:before {
      font-size: 18px;
      color: #36c0f4;
      padding-top: 20px;
    }
  }
  button:disabled {
    .el-icon-arrow-left,
    .el-icon-arrow-right {
      border: 1px solid #c7c7c7;
    }
    .el-icon-arrow-left:before,
    .el-icon-arrow-right:before {
      font-size: 18px;
      color: #c7c7c7;
    }
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
